export const deliveryOrders = [
  {
    id: 'DEL-001',
    customer: 'Kwame Mensah',
    phone: '+233 24 456 7890',
    address: 'East Legon, Accra',
    lat: 5.6360,
    lng: -0.1569,
    items: ['iPhone 15 Pro Max 256GB'],
    total: 8200,
    status: 'in_transit',
    driver: 'Emmanuel K.',
    eta: '14:30',
    priority: 'high',
    notes: 'Call before arrival',
  },
  {
    id: 'DEL-002',
    customer: 'Abena Osei',
    phone: '+233 20 123 4567',
    address: 'Cantonments, Accra',
    lat: 5.5717,
    lng: -0.1869,
    items: ['Samsung Galaxy S24 Ultra', 'Galaxy Buds2 Pro'],
    total: 9800,
    status: 'pending',
    driver: 'Emmanuel K.',
    eta: '15:15',
    priority: 'high',
    notes: 'Office building, ask for Abena at reception',
  },
  {
    id: 'DEL-003',
    customer: 'Kofi Agyeman',
    phone: '+233 55 789 0123',
    address: 'Osu, Accra',
    lat: 5.5560,
    lng: -0.1769,
    items: ['MacBook Air M3'],
    total: 12500,
    status: 'pending',
    driver: 'Emmanuel K.',
    eta: '16:00',
    priority: 'medium',
    notes: 'Fragile — handle with care',
  },
  {
    id: 'DEL-004',
    customer: 'Ama Darko',
    phone: '+233 27 345 6789',
    address: 'Labone, Accra',
    lat: 5.5650,
    lng: -0.1650,
    items: ['iPhone 14 Pro (Repaired)'],
    total: 650,
    status: 'pending',
    driver: 'Emmanuel K.',
    eta: '16:45',
    priority: 'low',
    notes: 'Repair pickup — get signature',
  },
  {
    id: 'DEL-005',
    customer: 'Yaw Boateng',
    phone: '+233 24 901 2345',
    address: 'Airport Residential, Accra',
    lat: 5.6050,
    lng: -0.1750,
    items: ['AirPods Pro 2', 'MagSafe Charger'],
    total: 2350,
    status: 'delivered',
    driver: 'Emmanuel K.',
    eta: '13:00',
    priority: 'medium',
    notes: '',
  },
];

export const drivers = [
  { id: 'd1', name: 'Emmanuel Kofi', phone: '+233 24 111 2222', status: 'active', deliveries: 3, completed: 1, rating: 4.9 },
  { id: 'd2', name: 'Akosua Mensah', phone: '+233 20 333 4444', status: 'idle', deliveries: 0, completed: 5, rating: 4.7 },
  { id: 'd3', name: 'Kwabena Asare', phone: '+233 55 555 6666', status: 'off_duty', deliveries: 0, completed: 8, rating: 4.8 },
];

export const deliveryZones = [
  { name: 'East Legon', fee: 50, eta: '30-45 min' },
  { name: 'Cantonments', fee: 40, eta: '25-40 min' },
  { name: 'Osu', fee: 35, eta: '20-35 min' },
  { name: 'Labone', fee: 40, eta: '25-40 min' },
  { name: 'Airport Residential', fee: 45, eta: '30-45 min' },
  { name: 'Tema', fee: 80, eta: '45-60 min' },
  { name: 'Spintex', fee: 60, eta: '35-50 min' },
  { name: 'Adenta', fee: 70, eta: '40-55 min' },
];
